/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    "Mettez en avant les messages importants à l'aide d'un spotlight visuel. {supportLink}",
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'En savoir plus sur les spotlights',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    "Mettez en avant les messages importants à l'aide d'un spotlight visuel.",
  'company-hub.spotlight-extension.config-panel.title': 'Spotlight',
  'company-hub.spotlight-extension.hub-element.description': 'Mettez en avant les messages importants',
  'company-hub.spotlight-extension.hub-element.title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Photographie de paysage de désert',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Concevez un spotlight pour mettre en avant vos informations les plus importantes. Donnez vie aux messages les plus importants avec des couleurs personnalisées, une image percutante et des mises en page flexibles.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Donnez un titre à votre spotlight',
  'company-hub.spotlight-extension.manifest.macro-description':
    "Mettez en avant les messages importants à l'aide d'un spotlight visuel.",
  'company-hub.spotlight-extension.manifest.macro-title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Spotlight [Nouveau]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Contenu',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'Général',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Mises en page',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    "Superposition d'une zone de texte sur une grande image",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    "Cadre de contenu à l'intérieur de l'image",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Image en taille réelle derrière votre contenu',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': "Arrière-plan de l'image",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Contenu avec un arrière-plan coloré en pleine largeur',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label': 'Arrière-plan uni',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    "Image de grande taille sur la droite avec beaucoup d'espace pour le contenu",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    "Design fractionné (le contenu d'abord)",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    "Image de grande taille sur la gauche avec beaucoup d'espace pour le contenu",
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    "Design fractionné (l'image d'abord)",
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Styles',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Description',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Les spotlights mettent en avant les messages importants pour votre équipe. Concevez votre spotlight avec une image, des couleurs personnalisées, une courte description et un lien.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Image',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Titre',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Donnez un titre à votre spotlight',
  'company-hub.spotlight-extension.spotlight.background.color': "Couleur d'arrière-plan",
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Les couleurs de votre texte et de votre arrière-plan ne sont pas optimales pour la lisibilité.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Les couleurs de votre texte et de votre arrière-plan sont optimales pour la lisibilité.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Couleur du texte',
};
